
export const CSS = {
    HeaderStyle : {
        img: {
            width: "75px"
        },
        navbar: {
            backgroundColor: "#7d674a",
            color: "black",
            position: "relative",
            zIndex: 3,
            position: "fixed",
            top: "0px"
        },
        navItem: {
            display: {
                xs: "flex",
                md: "flex"
            },
            // justifyContent: "end",
            flexGrow: 1,
            gap: "60px"
        },
        navLink: {
            color: "#ffffff",
            textDecoration: "none",
            textTransform: "capitalize",
            fontSize: "16px",
            paddingBottom: "3px",
            fontWeight: 500,
            "&.MuiIconButton-root":{
                padding:0
            }
        }
    },
    Login:{
        input: {
            border: "none",
            bordeRadius: "50px",
            "& .MuiInputBase-root": {
              bordeRadius: "50px",
              borderColor: " #02010100",
            },
            "& .MuiFormHelperText-root": {
              // Style the root element of MuiFormHelperText
              margin: 0,
              marginTop: 0,
              color: "red",
            },
      
          },
          logo: {
            color: "#7d674a",
            fontSize: "24px",
            fontWeight: 700,
          },
          logo1: {
            color: "#343568",
            fontSize: "20px",
            fontWeight: 700,
          },
          outBox: {
            width: "100%",
            //bgcolor: '#F3F0EE',
            overflow: "hidden",
            // pt: 5,
            // pb: 5,
          },
          mainBox: {
            // maxWidth: '1530px',
            width: "100%",
            minHeight: "500px",
            ml: "auto",
            mr: "auto",
            // p: '40px',
            bgcolor: "white",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: { xs: "center", md: "flex-end" },
            alignItems: "center",
          },
          leftBox: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: { xs: "100%", md: "50%" },
          },
          button: {
            width: "30%",
            "&.MuiButtonBase-root:hover": {
              bgcolor: "#CB2128",
              border: "1.5px solid #FF8D2A",
            },
            bgcolor: "#CB2128",
            color: "#FFFFFF",
            border: "1.5px solid #FF8D2A",
            mb: 2,
            mt: 4,
            borderRadius: "5px",
            fontSize: { xs: "16px", md: "16px", lg: "16px" },
            fontWeight: 400,
            textTransform: "none",
            transform: "skewX(-20deg)",
            "& .MuiButton-label": {
              transform: "skewX(20deg)",
            },
          },
          span: {
            color: "#ff0000"
          }
    },
    Dashboard: {
    box:{display:'flex',justifyContent:'space-between',ml:3,mr:4,mt:10},
    heading: {
            fontSize: "35px",
            fontWeight: 700,
            color:"black"
        },
        loader: { display: 'flex', justifyContent: 'center' },
        Progress: {
            display: 'flex',
            overflowX: 'hidden',
            height: '60px',
            width: '60px',
        },
    search:{
        // border: '1px solid #C8C8C8',
        '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent',
          },
          '&.MuiList-root': {
            // height: '300px',
          },
          "&.MuiFilledInput-root":{
            // height: '43px',
        },
          minWidth: '200px',
        //   height: '41.5px',
          width: '100%',
          fontSize: '16px',
          fontWeight: '400',
          ml:2
    }
    },
    Card: {
        list: { width: { xs: "auto", sm: 'auto' }, bgcolor: 'background.paper', p: 3 },
        box: { display: "flex", justifyContent: 'center' },
        box1: { display: {xs:'block', md:'flex'}, justifyContent: 'space-between', mt: 2 },
        item: { display: "block", boxShadow: "2px 2px 2px 2px", mb: 2, borderRadius: '10px', cursor: "pointer", width: "100%" },
        text: { fontSize: '24px', pb: 2, fontWeight: 700, wordBreak: "break-word", width: "87%" },
        text1: { fontSize: '16px', pb: 2 }

    },
    Modal: {
        modal: {
            padding: 2,
            // p: 2,
            borderRadius: 2,
        },
        box: { display: 'flex', justifyContent: "space-between", mt: 2 },
        head: { display: 'flex', justifyContent: "center", fontSize: "14px" },
        value: { display: 'flex', justifyContent: "center", fontSize: '26px', fontWeight: 600 },
        btn1: {
            textTransform: 'none', bgcolor: "red", color: 'white', mt: 2,ml:2, width: "100px", "&.MuiButton-root:hover": {
                bgcolor: "red"
            }
        },
        heading: { fontSize: "20px", fontWeight: 600 },
        field: {
            "&.MuiInputBase-root":{
                width:'100%'
            },
            display: 'block', '& .MuiFormHelperText-root': {
                // Style the root element of MuiFormHelperText
                margin: 0,
                marginLeft: 0,
            }, '& input[type=number]': {
                '-moz-appearance': 'textfield',
                '&::-webkit-outer-spin-button': {
                    '-webkit-appearance': 'none',
                    margin: 0,
                },
                '&::-webkit-inner-spin-button': {
                    '-webkit-appearance': 'none',
                    margin: 0,
                },
            },
        },
        validationStyle:{
            color: '#d32f2f',
            // margin: '10px',
            fontWeight: '500',
            fontSize: '12px',
        },
       
    },
    Bids: {
        Export:{
            color:"white",
            backgroundColor:"green",
            padding:"0px 20px",
            display:"flex",
            alignItems:"center",
            height:"40px",
            marginTop:"15px",
            textDecoration:"none"
        }
    },
    Settings :{
        box:{
            m:3,
            display:"flex"
        }
    },
    AdminDashboard:{
        Graph:{
            width:'100%'
        },
        view:{
            color:'white'
        }
    },
    Users:{
        addbtn:{
            width:'98.5%',
            display:"flex",
            justifyContent:"end",
            m:2,
        }
    }
}